import http from "../../utils/http-common";
import { useQuery } from "@tanstack/react-query";

export function useGroups() {
  const getGroups = async () => {
    const response = await http.get("/group");
    return response.data;
  };
  return useQuery({
    queryKey: ["group"],
    queryFn: getGroups,
  });
}
